import ApiService from "@/common/api/api.service";

const MMEService = {
  listar(porPagina = 0, pagina = 0) {
    return ApiService.get(`BoletoMME?TamanhoDaPagina=${porPagina}&NumeroDaPagina=${pagina}`);
  },
  buscarPorId(id) {
    return ApiService.get(`BoletoMME/${id}`);
  },
  salvar(form) {
    let result = [];
    if (!form.id) result = ApiService.post(`BoletoMME`, { ...form });
    else result = ApiService.put(`BoletoMME`, { ...form });
    return result;
  },
  excluir(id) {
    return ApiService.delete(`BoletoMME?id=${id}`);
  },
};

export default MMEService;
